import { useDispatch, useSelector } from 'react-redux';
import {
  getEntityType,
  setCommentPanelOpened,
  setRibbonPanelItem,
} from 'features/comments/commentsSlice';
import { CommentEventType, useEventSubscription } from '@pwc/event-hub-ui';
import { AnalysisInlineCommenting } from './mfe/analysis/index';
import { KFAInlineCommenting } from './mfe/kfa/index';
import { EntityType, CommentingProps } from './mfe/types';

const Components: Record<EntityType, (props: CommentingProps) => JSX.Element> =
  {
    analysis: AnalysisInlineCommenting,
    hypothesis: KFAInlineCommenting,
  };

const CommentingListMFE = (props: CommentingProps) => {
  const dispatch = useDispatch();
  const entityType = useSelector(getEntityType) as EntityType;
  const commentingProps = { ...props, entityType };
  const Component = Components[entityType];

  useEventSubscription(
    'commenting-open-comment-panel' as CommentEventType,
    () => {
      dispatch(setRibbonPanelItem({ type: 'comment' }));
      dispatch(setCommentPanelOpened(true));
    }
  );

  if (Component) {
    return <Component {...commentingProps} />;
  }
  return <></>;
};

export default CommentingListMFE;
